import * as React from "react";

// The source SVG wrapped these paths in a clipPath whose rect matches the
// viewBox exactly (so it clips nothing). Dropped here: the lead list renders
// this icon once per row, and a hard-coded clipPath id would repeat in the DOM.
const UnpinIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path d="M6 8.5V11" stroke="#1677FF" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.50001 4.67V3.5C7.50001 3.36739 7.55269 3.24021 7.64645 3.14645C7.74022 3.05268 7.8674 3 8.00001 3C8.26522 3 8.51958 2.89464 8.70711 2.70711C8.89465 2.51957 9.00001 2.26522 9.00001 2C9.00001 1.73478 8.89465 1.48043 8.70711 1.29289C8.51958 1.10536 8.26522 1 8.00001 1H3.94501"
      stroke="#1677FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1 1L11 11" stroke="#1677FF" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.5 4.5V5.38C4.4999 5.56604 4.44791 5.74837 4.34986 5.90648C4.25181 6.06459 4.11161 6.19221 3.945 6.275L3.055 6.725C2.88839 6.80779 2.74819 6.93541 2.65014 7.09352C2.55209 7.25163 2.5001 7.43396 2.5 7.62V8C2.5 8.13261 2.55268 8.25979 2.64645 8.35355C2.74021 8.44732 2.86739 8.5 3 8.5H8.5"
      stroke="#1677FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UnpinIcon;
